module.exports = __webpack_public_path__ + "static/digital-ocean2-03f7c596b6745f0750966ad66eb7bf41.png";